window.BLAtcPriceSync = window.BLAtcPriceSync || {
  owners: new Set(),

  getWrappers() {
    return Array.from(document.querySelectorAll('[data-persistent-btn-price]'));
  },

  hasActiveBundleOwner() {
    return this.owners.size > 0;
  },

  setDefaultPrice(price) {
    if (!price) return;

    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.defaultPrice = price;

      if (this.hasActiveBundleOwner()) return;

      wrapper.dataset.btnPriceSource = 'default';
      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay) {
        priceDisplay.textContent = price;
      }
    });
  },

  applyBundlePrice(owner, price) {
    if (!owner || !price) return;

    this.owners.add(owner);
    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.btnPriceSource = 'bundle';
      wrapper.dataset.bundlePriceOwner = owner;

      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay) {
        priceDisplay.textContent = price;
      }
    });
  },

  clearBundlePrice(owner) {
    if (owner) {
      this.owners.delete(owner);
    }

    if (this.hasActiveBundleOwner()) return;

    this.getWrappers().forEach((wrapper) => {
      wrapper.dataset.btnPriceSource = 'default';
      delete wrapper.dataset.bundlePriceOwner;

      const priceDisplay = wrapper.querySelector('[data-btn-price-display]');
      if (priceDisplay && wrapper.dataset.defaultPrice) {
        priceDisplay.textContent = wrapper.dataset.defaultPrice;
      }
    });
  },
};

window.BLBundlePriceState = window.BLBundlePriceState || {
  owners: new Map(),

  normalizePriceState(priceState) {
    if (!priceState) return null;

    if (typeof priceState === 'string') {
      return {
        displayPrice: priceState,
        compareAtPrice: '',
        isOnSale: false,
      };
    }

    const displayPrice = priceState.displayPrice || priceState.price || '';
    const compareAtPrice = priceState.compareAtPrice || '';
    const isOnSale = Boolean(
      priceState.isOnSale || (displayPrice && compareAtPrice)
    );

    if (!displayPrice) return null;

    return {
      displayPrice,
      compareAtPrice,
      isOnSale,
    };
  },

  ensureCSS() {
    if (document.getElementById('bl-bundle-price-state-css')) return;

    const style = document.createElement('style');
    style.id = 'bl-bundle-price-state-css';
    style.textContent = `
      body.wb-addon-active product-info .f-price > *,
      body.wb-addon-active .product__info-container .f-price > * {
        display: none !important;
      }
      body.wb-addon-active sticky-atc-bar .f-price > *,
      body.wb-addon-active .sticky-atc-bar .f-price > * {
        display: none !important;
      }
      .wb-addon-total-price {
        display: none;
        font-weight: 700;
      }
      .product__block--price .wb-addon-total-price {
        font-size: 1.96rem;
        line-height: 2.4rem;
      }
      @media (min-width: 768px) {
        .product__block--price .wb-addon-total-price {
          font-size: 2.8rem;
          line-height: 3.8rem;
        }
      }
      .sticky-atc-bar__product-info .wb-addon-total-price {
        font-size: inherit;
        line-height: inherit;
      }
      .wb-addon-total-price__current,
      .wb-addon-total-price__compare {
        display: inline-flex;
        align-items: center;
      }
      .wb-addon-total-price--sale .wb-addon-total-price__current {
        color: rgb(var(--color-product-price-sale)) !important;
      }
      .wb-addon-total-price__compare {
        margin-inline-start: 0.8rem;
        color: var(--color-product-price-regular, var(--color-foreground-lighten-60)) !important;
        font-size: var(--font-body-size);
        line-height: var(--font-body-line-height);
        font-weight: var(--font-body-weight);
      }
      body.wb-addon-active .wb-addon-total-price {
        display: inline !important;
      }
      body.wb-btn-ready [data-btn-price-wrapper] {
        display: inline-flex !important;
        align-items: center;
        gap: 8px;
        margin-left: 20px;
        z-index: 10;
        color: inherit;
        font-size: inherit;
        font-weight: inherit;
        line-height: inherit;
        letter-spacing: inherit;
        text-transform: inherit;
      }
      .btn__price-separator { opacity: 0.5; font-weight: 300; color: inherit; }
      [data-btn-price-display] { color: inherit; font-weight: inherit; }
      .btn__price-arrow { width: 1em; height: 1em; color: inherit; }
      [data-bl-price-locked] .f-price > * { display: none !important; }
      [data-bl-price-locked] .wb-addon-total-price { display: inline !important; }
    `;
    document.head.appendChild(style);
  },

  setOwnerState(owner, active, { buttonReady = false } = {}) {
    if (!owner) return;

    if (active) {
      this.owners.set(owner, { buttonReady });
    } else {
      this.owners.delete(owner);
    }

    this.syncBodyClasses();
  },

  syncBodyClasses() {
    const hasActiveOwner = this.owners.size > 0;
    const hasButtonReadyOwner = Array.from(this.owners.values()).some((state) => state?.buttonReady);

    document.body.classList.toggle('wb-addon-active', hasActiveOwner);
    document.body.classList.toggle('wb-btn-ready', hasButtonReadyOwner);
  },

  applyPriceNode(priceNode, priceState, { lock = false } = {}) {
    const normalizedState = this.normalizePriceState(priceState);
    if (!priceNode || !normalizedState) return;

    this.ensureCSS();

    const internalContainer = priceNode.querySelector('.f-price');
    if (!internalContainer) return;

    const nodeDocument = priceNode.ownerDocument || document;
    let bundlePriceEl = internalContainer.nextElementSibling;
    if (!bundlePriceEl || !bundlePriceEl.classList.contains('wb-addon-total-price')) {
      bundlePriceEl = nodeDocument.createElement('span');
      bundlePriceEl.className = 'wb-addon-total-price';
      internalContainer.parentNode.insertBefore(bundlePriceEl, internalContainer.nextSibling);
    }

    bundlePriceEl.classList.toggle('wb-addon-total-price--sale', normalizedState.isOnSale);
    bundlePriceEl.innerHTML = normalizedState.isOnSale && normalizedState.compareAtPrice
      ? `
        <span class="wb-addon-total-price__current f-price-item f-price-item--sale">${normalizedState.displayPrice}</span>
        <s class="wb-addon-total-price__compare f-price-item f-price-item--regular">${normalizedState.compareAtPrice}</s>
      `
      : `
        <span class="wb-addon-total-price__current f-price-item f-price-item--regular">${normalizedState.displayPrice}</span>
      `;

    if (lock) {
      priceNode.setAttribute('data-bl-price-locked', '');
    } else {
      priceNode.removeAttribute('data-bl-price-locked');
    }
  },

  clearPriceNode(priceNode) {
    if (!priceNode) return;
    priceNode.removeAttribute('data-bl-price-locked');
  },
};

window.BLVariantPrefetch = window.BLVariantPrefetch || {
  textCache: new Map(),
  pendingRequests: new Map(),
  preloadedImageKeys: new Set(),
  cacheTtl: 5 * 60 * 1000,
  maxEntries: 24,

  getCached(requestUrl) {
    const entry = this.textCache.get(requestUrl);
    if (!entry) return null;

    if (Date.now() - entry.ts > this.cacheTtl) {
      this.textCache.delete(requestUrl);
      return null;
    }

    return entry.text;
  },

  setCached(requestUrl, text) {
    if (this.textCache.size >= this.maxEntries) {
      const oldestKey = this.textCache.keys().next().value;
      if (oldestKey) this.textCache.delete(oldestKey);
    }

    this.textCache.set(requestUrl, {
      text,
      ts: Date.now(),
    });
  },

  preloadGalleryImages(responseText) {
    if (!responseText || typeof DOMParser === 'undefined') return;

    try {
      const doc = new DOMParser().parseFromString(responseText, 'text/html');
      const viewer = doc.querySelector('[id^="GalleryViewer"]') || doc.querySelector('media-gallery');
      if (!viewer) return;

      Array.from(viewer.querySelectorAll('img')).slice(0, 3).forEach((img) => {
        const srcset = img.getAttribute('srcset') || '';
        const src = img.getAttribute('src') || '';
        if ((!srcset && !src) || src.startsWith('data:') || (srcset && srcset.startsWith('data:'))) return;

        const key = srcset ? srcset.split(',')[0].trim().split(' ')[0] : src;
        if (!key || this.preloadedImageKeys.has(key)) return;
        this.preloadedImageKeys.add(key);

        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';

        if (srcset) {
          link.setAttribute('imagesrcset', srcset);
          const sizes = img.getAttribute('sizes');
          if (sizes) link.setAttribute('imagesizes', sizes);
        }

        if (src && !src.startsWith('data:')) {
          link.href = src;
        }

        document.head.appendChild(link);
      });
    } catch (error) {
      // Ignore malformed HTML or unsupported preload behavior.
    }
  },

  fetch(requestUrl, { signal } = {}) {
    const cachedText = this.getCached(requestUrl);
    if (cachedText) {
      return Promise.resolve(cachedText);
    }

    const pending = this.pendingRequests.get(requestUrl);
    if (pending) {
      return pending;
    }

    const promise = fetch(requestUrl, signal ? { signal } : {})
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((responseText) => {
        this.setCached(requestUrl, responseText);
        this.preloadGalleryImages(responseText);
        return responseText;
      })
      .finally(() => {
        if (this.pendingRequests.get(requestUrl) === promise) {
          this.pendingRequests.delete(requestUrl);
        }
      });

    this.pendingRequests.set(requestUrl, promise);
    return promise;
  },

  prefetch(requestUrl) {
    if (!requestUrl) return;
    this.fetch(requestUrl).catch(() => null);
  },
};

if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      abortController = undefined;
      onVariantChangeUnsubscriber = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();
        this.boundVariantPrefetchHandler = this.handleVariantPrefetchInteraction.bind(this);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get productId() {
        return this.getAttribute('data-product-id');
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get quantityInput() {
        return this.querySelector('quantity-input input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
          FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();
        this.resetBundlePricingStateIfInactive();

        this.currentVariant = this.getSelectedVariant(this);
        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }

        this.initVariantInteractionPrefetch();
        this.scheduleInitialVariantPrefetch();
        this.ensureBundleBaseVariantSelection();
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
      }

      initializeProductSwapUtility() {
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      initVariantInteractionPrefetch() {
        if (!this.variantSelectors || this.variantSelectors.dataset.blVariantPrefetchBound === 'true') return;

        this.variantSelectors.addEventListener('pointerenter', this.boundVariantPrefetchHandler, true);
        this.variantSelectors.addEventListener('focusin', this.boundVariantPrefetchHandler, true);
        this.variantSelectors.addEventListener('touchstart', this.boundVariantPrefetchHandler, { passive: true, capture: true });
        this.variantSelectors.dataset.blVariantPrefetchBound = 'true';
      }

      scheduleInitialVariantPrefetch() {
        if (!this.variantSelectors) return;

        const runPrefetch = () => {
          this.prefetchLikelyVariantRequests();
        };

        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(runPrefetch, { timeout: 800 });
        } else {
          window.setTimeout(runPrefetch, 250);
        }
      }

      handleVariantPrefetchInteraction(event) {
        const optionTarget = this.resolveOptionValueTarget(event.target);
        if (!optionTarget) return;

        const requestUrl = this.buildRequestUrlForOptionTarget(optionTarget);
        if (!requestUrl) return;

        window.BLVariantPrefetch?.prefetch?.(requestUrl);
      }

      resolveOptionValueTarget(node) {
        if (!node || !(node instanceof Element)) return null;

        if (node.matches('input[data-option-value-id]')) return node;
        if (node.matches('option[data-option-value-id]')) return node;

        const inputTarget = node.closest('input[data-option-value-id]');
        if (inputTarget) return inputTarget;

        const optionTarget = node.closest('option[data-option-value-id]');
        if (optionTarget) return optionTarget;

        const label = node.closest('label[for]');
        if (label?.htmlFor) {
          return this.querySelector(`#${CSS.escape(label.htmlFor)}`);
        }

        const select = node.closest('select');
        if (select?.selectedOptions?.[0]?.dataset?.optionValueId) {
          return select.selectedOptions[0];
        }

        return null;
      }

      getSelectedOptionValueMap() {
        const optionMap = new Map();
        if (!this.variantSelectors) return optionMap;

        this.variantSelectors.querySelectorAll('[data-option-position]').forEach((group) => {
          const position = parseInt(group.dataset.optionPosition, 10);
          if (!position) return;

          const checkedInput = group.querySelector('input[data-option-value-id]:checked');
          if (checkedInput?.dataset?.optionValueId) {
            optionMap.set(position, checkedInput.dataset.optionValueId);
            return;
          }

          const select = group.querySelector('select');
          const selectedOption = select?.selectedOptions?.[0];
          if (selectedOption?.dataset?.optionValueId) {
            optionMap.set(position, selectedOption.dataset.optionValueId);
          }
        });

        return optionMap;
      }

      buildOptionValueSelection(position, optionValueId) {
        if (!position || !optionValueId) return [];

        const selectedOptionMap = this.getSelectedOptionValueMap();
        selectedOptionMap.set(position, optionValueId);

        return Array.from(selectedOptionMap.entries())
          .sort((a, b) => a[0] - b[0])
          .map(([, valueId]) => valueId)
          .filter(Boolean);
      }

      buildRequestUrlForOptionTarget(optionTarget) {
        if (!optionTarget?.dataset?.optionValueId) return null;

        const optionGroup = optionTarget.closest('[data-option-position]');
        const optionPosition = parseInt(optionGroup?.dataset?.optionPosition, 10);
        if (!optionPosition) return null;

        const optionValues = this.buildOptionValueSelection(optionPosition, optionTarget.dataset.optionValueId);
        if (!optionValues.length) return null;

        const productUrl = this.pendingRequestUrl || optionTarget.dataset.productUrl || this.dataset.url;
        return this.buildRequestUrlWithParams(productUrl, optionValues, false);
      }

      hasBundleBaseVariantGuardContext(rootNode = this) {
        const root = rootNode?.matches?.('product-info')
          ? rootNode
          : rootNode?.querySelector?.('product-info') || rootNode;

        if (!root?.querySelector) return false;

        const translationEnabled = root.querySelector('[data-bl-basin-url-translation="true"]');
        if (!translationEnabled) return false;

        return Boolean(
          root.querySelector('[data-bl-grouping-root]')
          && root.querySelector('bl-product-customizer, [data-washbasin-selector-v2]')
        );
      }

      normalizeBundleOptionText(value) {
        return (value || '')
          .toString()
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .trim()
          .toLowerCase();
      }

      isBundleSafeFallbackValue(value) {
        const normalized = this.normalizeBundleOptionText(value);
        if (!normalized) return false;

        const exactFallbacks = [
          'ohne',
          'none',
          'no',
          'sin',
          'ninguno',
          'ninguna',
          'kein',
          'keine'
        ];

        if (exactFallbacks.includes(normalized)) return true;

        const withoutKeywords = ['ohne', 'without', 'sin', 'sans', 'senza', 'no '];
        const addonKeywords = [
          'waschtisch',
          'washbasin',
          'basin',
          'lavabo',
          'lavamanos',
          'wash basin'
        ];

        const hasWithoutKeyword = withoutKeywords.some((keyword) => normalized.includes(keyword));
        const hasAddonKeyword = addonKeywords.some((keyword) => normalized.includes(keyword));

        return hasWithoutKeyword && hasAddonKeyword;
      }

      findBundleSafeOptionCandidate(candidates) {
        return candidates.find((candidate) => {
          const value = candidate?.value
            || candidate?.textContent
            || candidate?.label
            || '';

          return this.isBundleSafeFallbackValue(value);
        }) || null;
      }

      getAutoResolvedOptionValues(rootNode) {
        const variantRoot = rootNode?.matches?.('variant-selects')
          ? rootNode
          : rootNode?.querySelector?.('variant-selects');
        if (!variantRoot) return null;

        const preferBundleSafeFallback = this.hasBundleBaseVariantGuardContext(rootNode);

        const groups = Array.from(variantRoot.querySelectorAll('[data-option-position]'))
          .sort((a, b) => {
            const aPos = parseInt(a.dataset.optionPosition, 10) || 0;
            const bPos = parseInt(b.dataset.optionPosition, 10) || 0;
            return aPos - bPos;
          });

        const optionValues = [];
        let changed = false;

        groups.forEach((group) => {
          const radioInputs = Array.from(group.querySelectorAll('input[data-option-value-id]'));
          if (radioInputs.length) {
            const checkedInput = radioInputs.find((input) => input.checked);
            const bundleSafeInput = preferBundleSafeFallback
              ? this.findBundleSafeOptionCandidate(radioInputs.filter((input) => !input.disabled))
              : null;
            const fallbackInput = bundleSafeInput
              || (checkedInput && !checkedInput.disabled
                ? checkedInput
                : radioInputs.find((input) => !input.disabled));

            if (!fallbackInput?.dataset?.optionValueId) return;

            optionValues.push(fallbackInput.dataset.optionValueId);
            if (fallbackInput !== checkedInput) {
              changed = true;
            }
            return;
          }

          const select = group.querySelector('select');
          const options = Array.from(select?.querySelectorAll('option[data-option-value-id]') || []);
          if (!options.length) return;

          const selectedOption = select.selectedOptions?.[0];
          const bundleSafeOption = preferBundleSafeFallback
            ? this.findBundleSafeOptionCandidate(options.filter((option) => !option.disabled))
            : null;
          const fallbackOption = bundleSafeOption
            || (selectedOption && !selectedOption.disabled
              ? selectedOption
              : options.find((option) => !option.disabled));

          if (!fallbackOption?.dataset?.optionValueId) return;

          optionValues.push(fallbackOption.dataset.optionValueId);
          if (fallbackOption !== selectedOption) {
            changed = true;
          }
        });

        return changed && optionValues.length ? optionValues : null;
      }

      ensureBundleBaseVariantSelection() {
        if (!this.hasBundleBaseVariantGuardContext(this)) return;

        const autoResolvedOptionValues = this.getAutoResolvedOptionValues(this);
        if (!autoResolvedOptionValues?.length) return;

        const targetId =
          this.variantSelectors?.querySelector('input:checked, select, input')?.id
          || this.variantSelectors?.id
          || this.id;
        const productUrl = this.pendingRequestUrl || this.dataset.url;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, autoResolvedOptionValues, false),
          targetId,
          callback: this.handleUpdateProductInfo(productUrl, viewMode, targetId, false),
        });
      }

      prefetchLikelyVariantRequests() {
        if (!this.variantSelectors) return;

        let queued = 0;
        const maxPrefetches = 8;

        this.variantSelectors.querySelectorAll('[data-option-position]').forEach((group) => {
          if (queued >= maxPrefetches) return;

          const currentChecked = group.querySelector('input[data-option-value-id]:checked');
          const candidates = currentChecked
            ? Array.from(group.querySelectorAll('input[data-option-value-id]')).filter((input) => input !== currentChecked)
            : Array.from(group.querySelectorAll('option[data-option-value-id]')).filter((option) => !option.selected);

          candidates.slice(0, Math.max(0, maxPrefetches - queued)).forEach((candidate) => {
            const requestUrl = this.buildRequestUrlForOptionTarget(candidate);
            if (!requestUrl) return;
            queued += 1;
            window.BLVariantPrefetch?.prefetch?.(requestUrl);
          });
        });
      }

      prepareIncomingServerFilteredMedia(incomingMedia, currentMedia) {
        if (!incomingMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]')) return null;

        const currentViewer = currentMedia?.querySelector('[id^="GalleryViewer"]');
        const currentGalleryHeight = currentMedia?.offsetHeight || 0;
        const currentViewerHeight = currentViewer?.offsetHeight || 0;

        incomingMedia.style.opacity = '0';
        incomingMedia.style.pointerEvents = 'none';
        if (currentGalleryHeight > 0) {
          incomingMedia.style.minHeight = `${currentGalleryHeight}px`;
        }

        const incomingViewer = incomingMedia.querySelector('[id^="GalleryViewer"]');
        if (incomingViewer && currentViewerHeight > 0) {
          incomingViewer.style.minHeight = `${currentViewerHeight}px`;
        }

        const incomingThumbnails = incomingMedia.querySelector('[id^="GalleryThumbnails"]');
        if (incomingThumbnails) {
          incomingThumbnails.style.opacity = '0';
          incomingThumbnails.style.pointerEvents = 'none';
        }

        return {
          galleryHeight: currentGalleryHeight,
          viewerHeight: currentViewerHeight,
        };
      }

      postProcessIncomingServerFilteredMedia(newMedia, metrics) {
        if (!newMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]')) return;

        const viewer = newMedia.querySelector('[id^="GalleryViewer"]');
        const thumbnails = newMedia.querySelector('[id^="GalleryThumbnails"]');
        const releaseMask = () => {
          newMedia.style.opacity = '';
          newMedia.style.pointerEvents = '';
          newMedia.style.minHeight = '';
          if (viewer) viewer.style.minHeight = '';
          if (thumbnails) {
            thumbnails.style.opacity = '';
            thumbnails.style.pointerEvents = '';
          }
        };

        if (typeof newMedia.destroySlider === 'function') newMedia.destroySlider();
        newMedia.sliderInstance = false;
        newMedia.thumbsInstance = false;
        if (typeof newMedia.init === 'function') {
          newMedia.init();
        }

        const firstImg = viewer?.querySelector('img');
        let rafAttempts = 0;
        const maxRafAttempts = 24;

        const isImageReady = () => !firstImg || (firstImg.complete && firstImg.naturalHeight > 0);
        const isReady = () => {
          const viewerReady = viewer?.classList.contains('swiper-initialized') || !viewer;
          const thumbsReady = thumbnails?.classList.contains('swiper-initialized') || !thumbnails;
          return viewerReady && thumbsReady && isImageReady();
        };

        const revealWhenStable = () => {
          rafAttempts += 1;
          if (isReady() || rafAttempts >= maxRafAttempts) {
            const slider = newMedia.sliderInstance?.slider;
            if (viewer?.style.minHeight && slider && typeof slider.updateAutoHeight === 'function') {
              slider.updateAutoHeight(0);
            }
            releaseMask();
            return;
          }
          requestAnimationFrame(revealWhenStable);
        };

        requestAnimationFrame(revealWhenStable);
        setTimeout(releaseMask, 1200);
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const hasGroupingBasedControl = Boolean(this.querySelector('[data-bl-grouping-root]'));
        const productUrl = hasGroupingBasedControl
          ? (this.pendingRequestUrl || this.dataset.url)
          : (target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url);
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;
        const viewMode = this.dataset.viewMode || 'main-product';

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage, viewMode, target.id)
            : this.handleUpdateProductInfo(productUrl, viewMode, target.id),
        });
      }

      get productForm() {
        return this.querySelector('form[is="product-form"');
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.resetFormState();
      }

      handleSwapProduct(productUrl, updateFullPage, viewMode, targetId, allowAutoResolve = true) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }

          const autoResolvedOptionValues = allowAutoResolve ? this.getAutoResolvedOptionValues(html) : null;
          if (autoResolvedOptionValues?.length) {
            this.renderProductInfo({
              requestUrl: this.buildRequestUrlWithParams(productUrl, autoResolvedOptionValues, updateFullPage),
              targetId,
              callback: this.handleSwapProduct(productUrl, updateFullPage, viewMode, targetId, false),
            });
            return;
          }

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));

          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;
            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
            HTMLUpdateUtility.viewTransition(
              document.getElementById('shopify-section-sticky-atc-bar'),
              html.getElementById('shopify-section-sticky-atc-bar'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }

          this.currentVariant = variant;
        };
      }

      handleUpdateProductInfo(productUrl, viewMode, targetId, allowAutoResolve = true) {
        return (html) => {
          const quickView = html.querySelector('#MainProduct-quick-view__content');
          if (quickView && viewMode === 'quick-view') {
            html = quickView.content.cloneNode(true);
          }

          const autoResolvedOptionValues = allowAutoResolve ? this.getAutoResolvedOptionValues(html) : null;
          if (autoResolvedOptionValues?.length) {
            this.renderProductInfo({
              requestUrl: this.buildRequestUrlWithParams(productUrl, autoResolvedOptionValues, false),
              targetId,
              callback: this.handleUpdateProductInfo(productUrl, viewMode, targetId, false),
            });
            return;
          }

          const variant = this.getSelectedVariant(html);
          const addonCustomizer = this.querySelector('bl-product-customizer');
          const addonBundlePreview =
            variant && addonCustomizer && typeof addonCustomizer.getBundlePreviewForVariant === 'function'
              ? addonCustomizer.getBundlePreviewForVariant(variant)
              : null;
          const hasActiveWashbasinSelection = Boolean(
            this.querySelector('[data-washbasin-selector-v2] .washbasin-selector__item.is-active:not([data-washbasin-none])')
          );
          const hasActiveProductAddonSelection = Boolean(
            this.querySelector('[data-product-addons] .product-addons__toggle:checked')
          );

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.initVariantInteractionPrefetch();
          this.scheduleInitialVariantPrefetch();
          this.updateURL(productUrl, variant?.id);
          this.updateShareUrl(variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          const incomingMedia = html.querySelector(`[id^="MediaGallery-${this.sectionId}"]`);
          const currentMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
          const hasServerFilteredGallery = Boolean(
            incomingMedia?.matches?.('media-gallery[data-bl-server-gallery-filter="true"]')
          );

          if (incomingMedia && currentMedia && hasServerFilteredGallery) {
            const mediaMetrics = this.prepareIncomingServerFilteredMedia(incomingMedia, currentMedia);
            HTMLUpdateUtility.viewTransition(
              currentMedia,
              incomingMedia,
              this.preProcessHtmlCallbacks,
              [
                ...this.postProcessHtmlCallbacks,
                (newNode) => this.postProcessIncomingServerFilteredMedia(newNode, mediaMetrics),
              ]
            );
          } else {
            this.updateMedia(variant);
          }

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              if (id === 'price' && !addonBundlePreview && !hasActiveWashbasinSelection && !hasActiveProductAddonSelection) {
                window.BLBundlePriceState?.setOwnerState?.('washbasin-v2', false);
                window.BLBundlePriceState?.setOwnerState?.('addon-configurator', false);
                window.BLBundlePriceState?.setOwnerState?.('product-addons', false);
                window.BLAtcPriceSync?.clearBundlePrice('washbasin-v2');
                window.BLAtcPriceSync?.clearBundlePrice('addon-configurator');
                window.BLAtcPriceSync?.clearBundlePrice('product-addons');
              }

              if (
                id === 'price'
                && addonBundlePreview
                && typeof addonCustomizer?.injectBundlePriceIntoNode === 'function'
              ) {
                addonCustomizer.injectBundlePriceIntoNode(source, addonBundlePreview);
              }

              destination.innerHTML = source.innerHTML;

              if (id === 'price' && source.hasAttribute('data-bl-price-locked')) {
                destination.setAttribute('data-bl-price-locked', '');
              } else if (id === 'price') {
                destination.removeAttribute('data-bl-price-locked');
              }

              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Barcode', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Badges', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('PricePerItem', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('ProductTitle');
          this.resetBundlePricingStateIfInactive();

          this.updateQuantityRules(this.sectionId, this.productId, html);
          this.querySelector(`#QuantityRules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#VolumeNote-${this.dataset.section}`)?.classList.remove('hidden');

          HTMLUpdateUtility.viewTransition(
            document.querySelector(`#SizeChart-${this.sectionId}`),
            html.querySelector(`#SizeChart-${this.sectionId}`),
            this.preProcessHtmlCallbacks,
            this.postProcessHtmlCallbacks
          );

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${this.sectionId}`);
          this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            FoxTheme.variantStrings.soldOut
          );

          this.currentVariant = variant;

          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant,
              },
            })
          );

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });

          this.updatePersistentAtcPrices(variant);
        };
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      hasBundlePricingContext() {
        const root = this.closest('.shopify-section') || document;
        return Boolean(root.querySelector('[data-washbasin-selector-v2], bl-product-customizer, [data-product-addons]'));
      }

      resetBundlePricingStateIfInactive() {
        if (this.hasBundlePricingContext()) return;

        document.body.classList.remove('wb-addon-active');
        document.body.classList.remove('wb-btn-ready');
        window.BLAtcPriceSync?.clearBundlePrice('washbasin-v2');
        window.BLAtcPriceSync?.clearBundlePrice('addon-configurator');
        window.BLAtcPriceSync?.clearBundlePrice('product-addons');
        window.BLBundlePriceState?.setOwnerState?.('washbasin-v2', false);
        window.BLBundlePriceState?.setOwnerState?.('addon-configurator', false);
        window.BLBundlePriceState?.setOwnerState?.('product-addons', false);

        [
          this.querySelector(`#price-${this.dataset.section}`),
          document.getElementById(`price-${this.sectionId}`),
          document.querySelector('sticky-atc-bar [id^="price-"]'),
        ]
          .filter(Boolean)
          .forEach((node) => {
            node.classList.remove('hidden');
            node.removeAttribute('data-bl-price-locked');
          });
      }

      formatAtcButtonPrice(variant) {
        if (!variant) return '';
        return FoxTheme.Currency.formatMoney(variant.price, FoxTheme.settings.moneyFormat);
      }

      updatePersistentAtcPrices(variant) {
        const formattedPrice = this.formatAtcButtonPrice(variant);
        if (!formattedPrice) return;
        window.BLAtcPriceSync?.setDefaultPrice(formattedPrice);
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const viewportPosition = this.captureViewportPosition();

        window.BLVariantPrefetch.fetch(requestUrl, { signal: this.abortController.signal })
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            this.focusTargetWithoutScroll(targetId, viewportPosition);
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      captureViewportPosition() {
        return {
          x: window.scrollX,
          y: window.scrollY,
        };
      }

      restoreViewportPosition(position) {
        if (!position) return;

        const restore = () => {
          if (window.scrollX !== position.x || window.scrollY !== position.y) {
            window.scrollTo(position.x, position.y);
          }
        };

        restore();
        requestAnimationFrame(restore);
      }

      focusTargetWithoutScroll(targetId, viewportPosition) {
        const target = document.getElementById(targetId);

        if (target) {
          try {
            target.focus({ preventScroll: true });
          } catch (error) {
            target.focus();
          }
        }

        this.restoreViewportPosition(viewportPosition);
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      updateURL(url, variantId) {
        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
      }

      updateVariantInputs(variantId) {
        document
          .querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`)
          .forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = variantId ?? '';
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
      }

      updateMedia(variant) {
        const productMedia = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (!productMedia) return; // Early return if productMedia is not found

        const setActiveMedia = () => {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.init();
            productMedia.setActiveMedia(variant);
            return true; // Indicate success
          }
          return false; // Indicate failure
        };

        if (!setActiveMedia()) {
          this.timer = setInterval(() => {
            if (setActiveMedia()) {
              clearInterval(this.timer);
            }
          }, 100);
        }
      }

      updateShareUrl(variantId) {
        if (!variantId) return;
        const shareButton = document.getElementById(`ProductShare-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${variantId}`);
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        const syncStickyButtons = () => {
          document.querySelectorAll('#shopify-section-sticky-atc-bar [name="add"]').forEach((stickyButton) => {
            const stickyButtonText = stickyButton.querySelector('span');
            if (disable) {
              stickyButton.setAttribute('disabled', 'disabled');
              stickyButton.setAttribute('aria-disabled', 'true');
              if (text && stickyButtonText) stickyButtonText.textContent = text;
            } else {
              stickyButton.removeAttribute('disabled');
              stickyButton.removeAttribute('aria-disabled');
              if (stickyButtonText) {
                stickyButtonText.innerHTML = FoxTheme.variantStrings.addToCartShort || FoxTheme.variantStrings.addToCart;
              }
            }
          });
        };

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.innerHTML = FoxTheme.variantStrings.addToCart;
        }

        syncStickyButtons();

        if (!modifyClass) return;
      }

      setUnavailable() {
        this.toggleAddButton(true, FoxTheme.variantStrings.unavailable);
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (price && this.hasBundlePricingContext()) {
          price.classList.add('hidden');
        } else if (price) {
          price.classList.remove('hidden');
          price.removeAttribute('data-bl-price-locked');
        }
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.setQuantityBoundries();
        if (!this.hasAttribute('data-original-section')) {
          this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
            FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }
      }

      setQuantityBoundries() {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityBoundries, {
          data: {
            sectionId: this.sectionId,
            productId: this.productId,
          },
        });
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.productIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart')?.classList.add('btn--loading');

        fetch(`${this.getAttribute('data-url')}?variant=${currentVariantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.sectionId, this.productId, parsedHTML);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart')?.classList.remove('btn--loading');
          });
      }

      updateQuantityRules(sectionId, productId, parsedHTML) {
        if (!this.quantityInput) return;

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.quantityRules, {
          data: {
            sectionId,
            productId,
            parsedHTML,
          },
        });

        this.setQuantityBoundries();
      }
    }
  );
}

if (!customElements.get('product-promotion-alert')) {
  customElements.define(
    'product-promotion-alert',
    class ProductPromotionAlert extends HTMLElement {
      constructor() {
        super();

        this.abortController = new AbortController();
        this.buttonEl = this.querySelector('button');
        this.buttonEl.addEventListener('click', this.onClick.bind(this), {
          signal: this.abortController.signal,
        });
      }

      onClick(evt) {
        evt.preventDefault();

        this.closest('.product__block').classList.add('hidden');
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
